import { TGetMatchOutputDto } from "@/api/services/main/match/dtos/get-match.dto";
import { TUpdateMatchReqDto } from "@/api/services/main/match/dtos/update-match.dto";
import { DATE_FORMAT_FOR_API } from "@/constants/datetime";
import { TMatchForm, TMatchOffice } from "@/features/match/types/MatchForm";
import { TMatchInfo } from "@/features/match/types/MatchInfo";
import dayjs from "dayjs";

export const convertMatchRes = (match?: TGetMatchOutputDto): Partial<TMatchInfo> => {
  return {
    matchName: match?.matchName ?? "",
    matchNameRomaji: match?.matchNameRomaji ?? "",
    matchLicenseNumber: match?.matchLicenseNumber ?? "",
    matchLicenseExpiryDate: match?.matchLicenseExpiryDate ? dayjs(match.matchLicenseExpiryDate) : null,
    zipCode: match?.zipCode ?? "",
    address: match?.address ?? "",
    prefecture: match?.prefecture ?? "",
    city: match?.city ?? "",
    contractStatus: match?.contractStatus ?? "",
    contractStartDate: match?.contractStartDate ? dayjs(match.contractStartDate) : null,
    trialStartDate: match?.trialStartDate ? dayjs(match.trialStartDate) : null,
    trialEndDate: match?.trialEndDate ? dayjs(match.trialEndDate) : null,
    contractEndDate: match?.contractEndDate ? dayjs(match.contractEndDate) : null,
    matchOffices: match?.matchOffices?.map((office) => ({ ...office, trainingDate: office.trainingDate ? dayjs(office.trainingDate) : null })) ?? [],
    representativeName: match?.representativeName,
    representativePosition: match?.representativePosition,
    phoneNumber: match?.phoneNumber,
    matchLicenseFilePath: match?.matchLicenseFilePath ?? null,
    jobInputRule: match?.jobInputRule ?? null,
    talentInputRule: match?.talentInputRule ?? null,
    talentCharacteristicMemoTemplate: match?.talentCharacteristicMemoTemplate ?? null,
    talentInterviewEvaluationTemplate: match?.talentInterviewEvaluationTemplate ?? null,
  };
};

export const convertMatchReq = (data: TMatchForm): TUpdateMatchReqDto => {
  return {
    matchName: data.matchName,
    matchNameRomaji: data.matchNameRomaji,
    matchLicenseExpiryDate: data.matchLicenseExpiryDate ? dayjs(data.matchLicenseExpiryDate).format(DATE_FORMAT_FOR_API) : null,
    zipCode: data.zipCode,
    address: data.address,
    prefecture: data.prefecture,
    city: data.city,
    matchOffices:
      data.matchOffices?.map(
        (office) =>
          ({
            ...office,
            trainingDate: office.trainingDate ? dayjs(office.trainingDate).format(DATE_FORMAT_FOR_API) : null,
          }) as TMatchOffice,
      ) ?? [],
    representativeName: data.representativeName,
    representativePosition: data.representativePosition,
    phoneNumber: data.phoneNumber,
    matchLicenseFilePath: data.matchLicenseFilePath,
    matchLicenseFile: data.matchLicenseFile,
    officeAppointmentFiles: data.officeAppointmentFiles,
    jobInputRule: data.jobInputRule,
    talentInputRule: data.talentInputRule,
    talentCharacteristicMemoTemplate: data.talentCharacteristicMemoTemplate,
    talentInterviewEvaluationTemplate: data.talentInterviewEvaluationTemplate,
  };
};
